import React from "react";

const NotSupportedIcon = ({ fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g
        id="Group_38"
        data-name="Group 38"
        transform="translate(-924.41 -541.388)"
      >
        <circle
          id="Ellipse_11"
          data-name="Ellipse 11"
          cx="8"
          cy="8"
          r="8"
          transform="translate(924.41 541.388)"
          fill={fill ? fill : "#e30202"}
        />
        <line
          id="Line_18"
          data-name="Line 18"
          y1="6"
          x2="6"
          transform="translate(929.5 546.5)"
          fill="none"
          stroke={stroke ? stroke : "#fff"}
          strokeWidth="1"
        />
        <g
          id="Ellipse_12"
          data-name="Ellipse 12"
          transform="translate(927 544)"
          fill="none"
          stroke={stroke ? stroke : "#fff"}
          strokeWidth="1"
        >
          <circle cx="5.5" cy="5.5" r="5.5" stroke="none" />
          <circle cx="5.5" cy="5.5" r="5" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default NotSupportedIcon;
